module.exports = __webpack_public_path__ + "62d7072328f118e749574cb5d9bb1ba6.svg";